<button
  mat-icon-button
  *ngIf="strokes?.length"
  nz-popover
  nzPopoverPlacement="top"
  nzPopoverTrigger="click"
  [nzPopoverContent]="popoverTpl"
  [(nzPopoverVisible)]="popoverVisible"
  class="draft-indicator"
  (click)="$event.stopPropagation()"
>
  <mat-icon class="draft-icon">gesture</mat-icon>
</button>
<ng-template #popoverTpl>
  <div class="draft-popover">
    <button class="draft-popover-close" (click)="popoverVisible = false">
      <mat-icon>close</mat-icon>
    </button>
    <svg viewBox="0 0 1 1" preserveAspectRatio="none" class="draft-svg">
      <path
        *ngFor="let stroke of strokes"
        [attr.d]="getSvgPath(stroke.points)"
        fill="none"
        stroke="#000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        vector-effect="non-scaling-stroke"
      />
    </svg>
  </div>
</ng-template>
